export default {

  SET_DPR_HEADER: (state, payload) => { 
    state.dprHeader = payload;
    state.dprFileId = (payload || {}).dprFileId;
  },

  SET_DPR_HEADER_NO: (state, payload) => state.dprHeaderNo = payload,
  SET_COORDS: (state, payload) => state.coordinates = payload

}